import { render, staticRenderFns } from "./casting-calls-discussions.vue?vue&type=template&id=39825d51&scoped=true&"
import script from "./casting-calls-discussions.vue?vue&type=script&lang=ts&"
export * from "./casting-calls-discussions.vue?vue&type=script&lang=ts&"
import style0 from "./casting-calls-discussions.vue?vue&type=style&index=0&id=39825d51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39825d51",
  null
  
)

export default component.exports